/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AuthScopes = {
    readusers: 'read:users',
    writeusers: 'write:users',
    readgames: 'read:games',
    writegames: 'write:games',
    readroles: 'read:roles',
    writeroles: 'write:roles',
    readscopes: 'read:scopes',
    readplayer_details: 'read:player-details',
    readplayer_coupons: 'read:player-coupons',
    readplayer_scans: 'read:player-scans',
    readbarcodes: 'read:barcodes',
    readplayer_spins: 'read:player-spins',
    readclaim_centers: 'read:claim-centers',
    readclaim_center_reservations: 'read:claim-center-reservations',
    writeclaim_center_reservations: 'write:claim-center-reservations',
    writeclaim_center_admin: 'write:claim-center-admin',
    writeclaim_center_exceptions: 'write:claim-center-exceptions',
    writeclaim_center_schedules: 'write:claim-center-schedules',
    readreports: 'read:reports',
    readcoupons: 'read:coupons',
    writecoupons: 'write:coupons',
    readsearch: 'read:search',
    writesearch: 'write:search',
    readimports: 'read:imports',
    readplugins: 'read:plugins',
    writeplugins: 'write:plugins',
    readapi_keys: 'read:api_keys',
    writeapi_keys: 'write:api_keys',
    readpromotion_campaigns: 'read:promotion-campaigns',
    writepromotion_campaigns: 'write:promotion-campaigns',
    readcustomer_config: 'read:customer-config',
    writecustomer_config: 'write:customer-config',
    readticket_scanner_downtime: 'read:ticket-scanner-downtime',
    writeticket_scanner_downtime: 'write:ticket-scanner-downtime',
    readpush_notifications: 'read:push-notifications',
    writepush_notifications: 'write:push-notifications',
    readpam_verifications: 'read:pam-verifications',
    writepam_verifications: 'write:pam-verifications',
    unknown_default_open_api: '11184809'
} as const;
export type AuthScopes = typeof AuthScopes[keyof typeof AuthScopes];


export function instanceOfAuthScopes(value: any): boolean {
    for (const key in AuthScopes) {
        if (Object.prototype.hasOwnProperty.call(AuthScopes, key)) {
            if (AuthScopes[key as keyof typeof AuthScopes] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AuthScopesFromJSON(json: any): AuthScopes {
    return AuthScopesFromJSONTyped(json, false);
}

export function AuthScopesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthScopes {
    return json as AuthScopes;
}

export function AuthScopesToJSON(value?: AuthScopes | null): any {
    return value as any;
}

